import i18next from 'i18next';

export default function getLocale() {
  return i18next.language.startsWith('pt') ? 'pt-BR' : 'en';
}
